import {
  ImageConvertStatus,
  isImageConvertStatusIncorrectPages,
} from 'shared/domain/imageConvertStatus/imageConvertStatus';
import { isMapExtension, isPdfExtension } from './availableExtensionsAsMap';

/** Why a version cannot be a map, as the user is told it (PT-7117). */
export enum MapUnsuitableReason {
  /** Not a PDF nor a png, jpg, jpeg or webp image. */
  unsupportedFormat = 'unsupportedFormat',
  /** A PDF of more than one page: only a single page PDF can be a map. */
  multiPagePdf = 'multiPagePdf',
}

/** What the reason is read from: the version's file; the extension is missing before the file is known. */
export interface MapUnsuitableFile {
  extension: string | undefined;
  imageConvertStatus?: ImageConvertStatus;
}

/**
 * Why the version cannot be a map, read from its file: a format no map is drawn
 * from, or a PDF with more pages than one; `undefined` when the file does not
 * say (e.g. it is not uploaded or converted yet).
 */
export function findMapUnsuitableReason({ extension, imageConvertStatus }: MapUnsuitableFile): MapUnsuitableReason | undefined {
  if (!isMapExtension(extension)) {
    return MapUnsuitableReason.unsupportedFormat;
  }
  return isPdfExtension(extension) && isImageConvertStatusIncorrectPages(imageConvertStatus)
    ? MapUnsuitableReason.multiPagePdf
    : undefined;
}

/** The file format as a sentence names it, e.g. `XLSX`. */
export function formatMapFileFormat(extension: string | undefined): string {
  return (extension ?? '').toUpperCase();
}
